import SectionHeader from '@/components/base/SectionHeader';
import ArticleCard from '@/components/base/ArticleCard';
import { getFeaturedArticles } from '@/mocks/article';

export default function ArticleRecommend() {
  const featured = getFeaturedArticles();

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <SectionHeader
          title="精选资讯"
          subtitle="最新动漫资讯与深度解读"
          linkTo="/articles"
          linkLabel="全部文章"
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {featured.map((article) => (
            <ArticleCard key={article.id} article={article} variant="horizontal" />
          ))}
        </div>
      </div>
    </section>
  );
}